module.exports = __webpack_public_path__ + "static/media/logo.55bc5529.svg";